import React from 'react';
import ContentLoader from 'react-content-loader';
import InputMask from 'react-input-mask';
import { useHistory, withRouter } from 'react-router-dom';
import { Button, Card, Grid, Page, Form, FormTextInput } from 'tabler-react';

import PrivatePage from './PrivatePage';
import { UseDebounce } from '../components';
import { Backend, viacep } from '../services';

function ProfilePage(props) {
  const [name, setName] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [zipcode, setZipcode] = React.useState('');
  const debounceZipcode = UseDebounce(zipcode, 500);
  const [street, setStreet] = React.useState('');
  const [number, setNumber] = React.useState('');
  const [district, setDistrict] = React.useState('');
  const [complement, setComplement] = React.useState('');
  const [city, setCity] = React.useState('');
  const [province, setProvince] = React.useState('');
  const [mobilePhone, setMobilePhone] = React.useState('');
  const [landlinePhone, setLandlinePhone] = React.useState('');
  const [errors, setErrors] = React.useState(null);
  const [submitting, setSubmitting] = React.useState(false);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    (async () => {
      setLoading(true);

      try {
        const res = await Backend.getProfile();
        setName(res.data.name);
        setEmail(res.data.email);
        setStreet(res.data.addressStreet);
        setNumber(res.data.addressNumber);
        setDistrict(res.data.addressDistrict);
        setComplement(res.data.addressComplement);
        setCity(res.data.addressCity);
        setZipcode(res.data.addressZipcode);
        setProvince(res.data.addressProvince);
        setMobilePhone(res.data.mobilePhone);
        setLandlinePhone(res.data.landlinePhone);
      } catch (err) {
        console.error(err);
        alert('Something went wrong');
      }

      setLoading(false);
    })();
  }, []);

  React.useEffect(() => {
    if (zipcode.length < 8) return;
    
    (async () => {
      const zipcodeData = await viacep.getAddressByZipcode(zipcode.replace(/\D/g, ''));

      if (!zipcodeData) return;

      setStreet(zipcodeData.logradouro);
      setDistrict(zipcodeData.bairro);
      setCity(zipcodeData.localidade);
      setProvince(zipcodeData.uf);
    })();
  }, [debounceZipcode]);
  
  const onSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    setSubmitting(true);
    setErrors(null);

    try {
      await Backend.updateProfile({
        name,
        email,
        addressZipcode: zipcode,
        addressStreet: street,
        addressNumber: number,
        addressComplement: complement,
        addressDistrict: district,
        addressCity: city,
        addressState: province,
        mobilePhone: mobilePhone,
        landlinePhone: landlinePhone
      });

      alert('Cadastro atualizado! Parabéns o seu cadastro está em dia!');
      
      setSubmitting(false);
      setLoading(false);
    } catch (err) {
      setSubmitting(false);
      setLoading(false);

      if (err.response.status === 400) {
        const fields = err.response.data.reduce((obj, i) => {
          obj[i.field] = i.message;
          return obj;
        }, {});

        return setErrors(fields);
      }

      console.log(err.response);
      alert('Something went wrong');
    }
  };

  return (
    <PrivatePage>
      {
        loading ? <Page.Content><ContentLoader foregroundColor="#DDD"/></Page.Content>
        :
        <Page.Content>
          <Page.Header title="Atualizar Perfil" subTitle="Preencha o formulário abaixo para atualizar o seu cadastro"/>
          <Form className="card" onSubmit={onSubmit}>
            <Card.Body className="p-6">
              <Grid>
                <Grid.Row>
                  <Grid.Col sm="12" lg="4">
                    <FormTextInput
                      name="name"
                      label="Nome Completo"
                      onChange={(e) => {setName(e.target.value)}}
                      value={name}
                      error={errors && errors.name}
                    />
                    <FormTextInput
                      name="email"
                      label="E-mail"
                      onChange={(e) => {setEmail(e.target.value)}}
                      value={email}
                      error={errors && errors.email}
                    />
                    <InputMask mask="(99) 99999-9999" value={mobilePhone} onChange={(e) => {setMobilePhone(e.target.value)}}>
                      {(inputProps) => 
                        <FormTextInput
                          {...inputProps}
                          name="mobilePhone"
                          label="Celular"
                          error={errors && errors.mobilePhone}
                        />
                      }
                    </InputMask>

                    <InputMask mask="(99) 9999-9999" value={landlinePhone} onChange={(e) => {setLandlinePhone(e.target.value)}}>
                      {(inputProps) => 
                        <FormTextInput
                          {...inputProps}
                          name="landlinePhone"
                          label="Telefone"
                          error={errors && errors.landlinePhone}
                        />
                      }
                    </InputMask>
                  </Grid.Col>

                  <Grid.Col sm="12" lg="4">
                    <InputMask mask="99999-999" value={zipcode} onChange={(e) => {setZipcode(e.target.value)}}>
                      {(inputProps) => 
                        <FormTextInput
                          {...inputProps}
                          name="zipcode"
                          label="CEP"
                          placeholder="00000-000"
                          error={errors && errors.addressZipcode}
                        />
                      }
                    </InputMask>
                    
                    <FormTextInput
                      name="street"
                      label="Rua"
                      onChange={(e) => {setStreet(e.target.value)}}
                      value={street}
                      error={errors && errors.addressStreet}
                    />
                    <FormTextInput
                      name="number"
                      label="Número"
                      onChange={(e) => {setNumber(e.target.value)}}
                      value={number}
                      error={errors && errors.addressNumber}
                    />
                    <FormTextInput
                      name="complement"
                      label="Complemento"
                      onChange={(e) => {setComplement(e.target.value)}}
                      value={complement}
                      error={errors && errors.complement}
                    />
                  </Grid.Col>

                  <Grid.Col sm="12" lg="4">
                    <FormTextInput
                      name="district"
                      label="Bairro"
                      onChange={(e) => {setDistrict(e.target.value)}}
                      value={district}
                      error={errors && errors.addressDistrict}
                    />
                    <FormTextInput
                      name="city"
                      label="Cidade"
                      onChange={(e) => {setCity(e.target.value)}}
                      value={city}
                      error={errors && errors.addressCity}
                    />
                    <FormTextInput
                      name="province"
                      label="Estado"
                      onChange={(e) => {setProvince(e.target.value)}}
                      value={province}
                      error={errors && errors.adressState}
                    />
                  </Grid.Col>
                </Grid.Row>
              </Grid>
            

              <Form.Footer>
                <Button loading={submitting} type="submit" color="primary" block>Atualizar Perfil</Button>
              </Form.Footer> 
            </Card.Body>
          </Form>
        </Page.Content>
      }
    </PrivatePage>
  )
}

export default withRouter(ProfilePage);